<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="header">
            <div class="title-color">
            <h1 *ngIf="!group">CREAR GRUPO</h1>
            </div>
            <div class="title-color">
            <h1 *ngIf="group">EDITAR GRUPO</h1>
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="groupForm" (ngSubmit)="onCreateGroup()">
                <div class="line">
                    <div class="column-md-4 column-lg-4 column-sm-6">
                        <mat-form-field appearance="outline">
                            <mat-label>Nombre del grupo</mat-label>
                            <input
                                type="text"
                                matInput
                                required
                                formControlName="name"
                            />
                        </mat-form-field>
                    </div>
                    <div class="column-md-2 column-lg-2 column-sm-6">
                        <mat-checkbox
                            matInput
                            formControlName="create"
                            title="create"
                        >
                            Create
                        </mat-checkbox>
                    </div>
                    <div class="column-md-2 column-lg-2 column-sm-6">
                        <mat-checkbox
                            matInput
                            formControlName="update"
                            title="update"
                        >
                            Update
                        </mat-checkbox>
                    </div>
                    <div class="column-md-2 column-lg-2 column-sm-6">
                        <mat-checkbox
                            matInput
                            formControlName="delete"
                            title="delete"
                        >
                            Delete
                        </mat-checkbox>
                    </div>
                    <div class="column-md-2 column-lg-2 column-sm-6">
                        <mat-checkbox
                            matInput
                            formControlName="read"
                            title="read"
                        >
                            Read
                        </mat-checkbox>
                    </div>
                    <div class="duallist-ui">
                    <dual-list
                        display="name"
                        key="id"
                        [source]="permisions"
                        [(destination)]="selected"
                        height="250px"
                        [format]="format"
                        [filter]="true"
                    >
                    </dual-list>
                    </div>
                </div>

                <br />
                <button class="primary-button" type="submit">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button
                    type="button"
                    (click)="closeDialog()"
                    class="secondary-button"
                    id="cancelar"
                >
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
